import React, {useEffect, useState} from "react";
import { XBEmenuProducts } from "./XBEmenuProducts";



const menu = {
  'Products': {
    url: "https://xsolla.com/products",
  },
  'Company': {
    url: "https://xsolla.com/about",
  },
  'Developers': {
    url: "https://developers.xsolla.com/",
    target: '_blank',
  },
  'Pricing': {
    url: "https://xsolla.com/pricing",
  },
  'Gamer Support': {
    url: "https://xsolla.com/gamer-support/",
  },
  'Products': {
    url: "https://xsolla.com/partner-support",
  },
  'Partner Support': {
    url: "https://xsolla.com/products",
  },
  'Log in': {
    url: "https://publisher.xsolla.com",
  },
}


export function XBEmenu() {

  const [jq, setJq] = useState(false);
  const [jq2, setJq2] = useState(false);



  const [shown, setShown] = useState(null);




  return (
    <div className="m0" data-menu="target">




      <XBEmenuProducts shown={shown === 'products' ? true : false} handleHide={setShown}/>



      <div id="menu" className="xsolla_menu">
        {/* <div
          data-w-id="6cfed1ce-03e2-f5e2-dd52-15427a9972ed"
          className="mobile-menu-2 hide"
        >
          <div className="menu_width">
            <div className="h_block">
              <div className="menu_left">
                <div className="h_pop_mainblock">
                  <div className="mobmenu_column">
                    <div className="h_pop_title-block">
                      <div className="separator" />
                    </div>
                    <a
                      href="https://xsolla.com/products"
                      className="mobmenu_list w-inline-block"
                    >
                      <div className="h_mobmenu-2">Products</div>
                    </a>
                    <a
                      href="https://xsolla.com/about"
                      className="mobmenu_list w-inline-block"
                    >
                      <div className="h_mobmenu-2">Company</div>
                    </a>
                  </div>
                  <div className="mobmenu_column">
                    <div className="h_pop_title-block" />
                    <a
                      href="https://developers.xsolla.com/"
                      target="_blank"
                      className="mobmenu_list w-inline-block"
                    >
                      <div className="h_mobmenu-2">Developers</div>
                    </a>
                    <a
                      href="https://xsolla.com/pricing"
                      className="mobmenu_list w-inline-block"
                    >
                      <div className="h_mobmenu-2">Pricing</div>
                    </a>
                  </div>
                  <div className="mobmenu_column">
                    <div className="h_pop_title-block" />
                    <a
                      href="https://xsolla.com/gamer-support/"
                      className="mobmenu_list w-inline-block"
                    >
                      <div className="h_mobmenu-2">Gamer Support</div>
                    </a>
                    <a
                      href="https://xsolla.com/partner-support"
                      className="mobmenu_list w-inline-block"
                    >
                      <div className="h_mobmenu-2">Partner Support</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         */}
        <a href="#" className="h_right-2 w-inline-block">
          <div className="h_logo-3">
            <div className="xsolla_logo_top-2" />
          </div>
          <div className="h_logotype">
            <div>
              Xsolla
              <br />
            </div>
          </div>
        </a>
        <a
          data-menu="trigger"
          href="#"
          data-w-id="6cfed1ce-03e2-f5e2-dd52-15427a997312"
          className="hamburger-wrapper w-inline-block"
        >
          <div
            data-w-id="6cfed1ce-03e2-f5e2-dd52-15427a997313"
            className="burger-line"
          />
          <div
            data-w-id="6cfed1ce-03e2-f5e2-dd52-15427a997314"
            className="burger-line"
          />
          <div
            data-w-id="6cfed1ce-03e2-f5e2-dd52-15427a997315"
            className="burger-line"
          />
        </a>



<div className="h_right2"><ul className="h_menu w-list-unstyled"><li className="h_menu_li hidden"><div className="bt_header-2 bt_header--active"><div>Solutions</div></div></li><li className="h_menu_li"><div className="bt_header shown"><div>Solutions</div></div></li><li className="h_menu_li"><div data-menu="trigger" className="bt_header expand"><div>Products</div></div></li><li className="h_menu_li hide"><div className="bt_header-2 expand"><div className="header_pop-2 hide"><div className="h_width"><div className="h_block"><div className="h_pop_left"><div className="h_pop_mainblock"><div className="h_pop_column"><div className="h_pop_title-block"><div className="h_pop_title-2"><div className="h_pop_title-2"><strong>LEARN AND CONNECT</strong></div></div><div className="separator" /></div><a href="https://xsolla.com/clients" className="h_pop_li w-inline-block"><div className="h_pop_li_title-2">Clients</div><div className="h_pop_li_text">Partnership stories</div></a><a href="https://xsolla.com/about" className="h_pop_li w-inline-block"><div className="h_pop_li_title-2">About Us</div><div className="h_pop_li_text">The Xsolla story</div></a><a href="https://xsolla.com/contact-sales" className="h_pop_li w-inline-block"><div className="h_pop_li_title-2">Contact Sales</div><div className="h_pop_li_text">Getting in touch</div></a></div><div className="h_pop_column"><a href="https://xsolla.com/global-reach" className="h_pop_li first w-inline-block"><div className="h_pop_li_title-2">Global Reach</div><div className="h_pop_li_text">Everywhere we are</div></a><a href="https://xsolla.com/security" className="h_pop_li w-inline-block"><div className="h_pop_li_title-2">Security</div><div className="h_pop_li_text">Xsolla infrastructure</div></a><a href="https://xsolla.com/events" className="h_pop_li w-inline-block"><div className="h_pop_li_title-2">Events</div><div className="h_pop_li_text">Let's meet</div></a></div></div></div></div></div></div><div>Company</div><div className="header_triangle-2" /><div className="pop_bg hide" /></div></li><li className="h_menu_li"><a href="https://xsolla.com/pricing" className="bt_header w-inline-block"><div>Pricing</div></a></li><li className="h_menu_li"><a href="https://xsolla.com/about" className="bt_header w-inline-block"><div>Company</div></a></li><li className="h_menu_li"><a href="https://developers.xsolla.com/" target="_blank" className="bt_header w-inline-block"><div>Documentation</div></a></li></ul><ul className="pk_menu_right w-list-unstyled"><li className="h_menu_li"><div className="h_lang0"><div className="h_lang_but"><div>En</div></div><div className="h_lang_p-2"><div className="h_lang_p_b-2"><a href="#" className="h_lang_p_li-2 w-inline-block"><div>English</div></a><a href="#" className="h_lang_p_li-2 w-inline-block"><div>Russian</div></a></div></div></div></li><li className="h_menu_li hide"><div className="bt_header-2 expand"><div className="header_pop-2 hide"><div className="h_width"><div className="h_block"><div className="h_pop_left"><div className="h_pop_mainblock"><div className="h_pop_column"><div className="h_pop_title-block"><div className="h_pop_title-2"><div className="h_pop_title-2">FIND ANSWERS</div></div><div className="separator" /></div><a href="https://xsolla.com/gamer-support" className="h_pop_li w-inline-block"><div className="h_pop_li_title-2">Game Support</div><div className="h_pop_li_text">Video game-related questions</div></a><a href="https://xsolla.com/partner-support" className="h_pop_li w-inline-block"><div className="h_pop_li_title-2">Partner Support</div><div className="h_pop_li_text">Questions about products and services</div></a></div></div></div></div></div></div><div>Support</div><div className="header_triangle-2" /><div className="pop_bg hide" /></div></li><li className="h_menu_li"><a href="https://xsolla-com-ffr.webflow.io/" className="bt_header expand w-inline-block"><div>Log In</div></a></li><li className="h_menu_li"><a href="https://xsolla-com-ffr.webflow.io/" className="bt_header w-inline-block"><div>Gamer Support</div></a></li></ul></div>



      </div>





    </div>
  );
}



